import { PharmacyService } from './../../../services/pharmacy.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SaleItemRemoveService extends PharmacyService {
  modelPath = 'pharmacy/sale_items';
}
